import React, { useEffect, useState } from "react";
import FileManagerListing from "./FileListing";
import { columnTypes } from "src/components/UI/atoms/ATMTable/ATMTable";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import {
  setIsOpenAddDialog,
  setIsOpenEditDialog,
  setPage,
  setRowsPerPage,
  setSearchValue,
  setIsTableLoading,
  setItems,
  setTotalItems,
} from "src/redux/slices/FileManagerSlice";
import ATMMenu from "src/components/UI/atoms/ATMMenu/ATMMenu";
import { showConfirmationDialog } from "src/utils/showConfirmationDialog";
import { showToast } from "src/utils/showToaster";
import AddFileManagerWrapper from "../Add/AddFileWrapper";

import { usePermission } from "src/hooks/usePermission";
import { useGetAllFileDataQuery } from "src/services/FileManagerService";

type Props = {};

const FileManagerListingWrapper = (props: Props) => {
  const dispatch = useDispatch();
  const {
    items,
    totalItems,
    page,
    rowsPerPage,
    searchValue,
    isOpenAddDialog,
    isOpenEditDialog,
    isTableLoading,
  } = useSelector((state: RootState) => state.fileManager);


  const { data, isLoading, isFetching } = useGetAllFileDataQuery({
    limit: rowsPerPage,
    searchValue: searchValue,
    params: ["name"],
    page: page,
    filterBy: [],
    dateFilter: {},
    orderBy: "createdAt",
    orderByValue: -1,
    isPaginationRequired: true,
  });

  // Setting Module Data
  useEffect(() => {
    if (isLoading || isFetching) {
      dispatch(setIsTableLoading(true));
    } else {
      dispatch(setItems(data?.data || []));
      dispatch(setIsTableLoading(false));
      dispatch(setTotalItems(data?.totalItem || 0));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isLoading, isFetching]);

  // const handleDeleteFileManager = (row: string) => {
  //   showConfirmationDialog({
  //     title: "Hands Up",
  //     text: "Are you sure want to delete this FileManager ?",
  //     icon: "question",
  //     showCancelButton: true,
  //     next: (result) => {
  //       if (result?.isConfirmed) {
  //         deleteFileManager(row).then((res: any) => {
  //           if (res.error) {
  //             showToast("error", res?.error?.data?.message);
  //           } else {
  //             showToast("success", res?.data?.message);
  //           }
  //         });
  //       }
  //     },
  //   });
  // };

  // const handleChangeStatusFileManager = (row: string) => {
  //   showConfirmationDialog({
  //     title: "Hands Up",
  //     text: "Are you sure want to change status of this FileManager ?",
  //     icon: "question",
  //     showCancelButton: true,
  //     next: (result) => {
  //       if (result?.isConfirmed) {
  //         changeStatusFileManager({ id: row }).then((res: any) => {
  //           if (res.error) {
  //             showToast("error", res?.error?.data?.message);
  //           } else {
  //             showToast("success", res?.data?.message);
  //           }
  //         });
  //       }
  //     },
  //   });
  // };

  const moduleName = "FileManager";

  const canEdit = usePermission(moduleName, "UPDATE");
  const canDelete = usePermission(moduleName, "DELETE");
  const canActive = usePermission(moduleName, "ACTIVE/DEACTIVE");

  const columns: columnTypes[] = [
    {
      field: "name",
      headerName: "File Name",
      flex: "flex-[1_1_0%]",
    },
    {
      field: "url",
      headerName: "File Url",
      flex: "flex-[1_1_0%]",
    },
    // {
    //   field: "action",
    //   headerName: "Actions",
    //   flex: "flex-[1_1_0%]",
    //   align: "center",
    //   extraClasses: "",
    //   renderCell: (row: any) => {
    //     const options = [];

    //     if (canEdit) {
    //       options.push({
    //         label: "Edit",
    //         onClick: () => {
    //           dispatch(setIsOpenEditDialog(true));
    //           setSelectedFileManagerId(row?._id);
    //         },
    //       });
    //     }

    //     if (canActive) {
    //       options.push({
    //         label: "Active/Deactive",
    //         onClick: () => {
    //           handleChangeStatusFileManager(row?._id);
    //         },
    //       });
    //     }

    //     if (canDelete) {
    //       options.push({
    //         label: "Delete",
    //         onClick: () => {
    //           handleDeleteFileManager(row?._id);
    //         },
    //       });
    //     }

    //     return <ATMMenu options={options} />;
    //   },
    // },
  ];

  return (
    <>
      <div>
        <FileManagerListing
          columns={columns}
          rows={items}
          paginationProps={{
            isTableLoading,
            totalItems,
            page,
            rowsPerPage,
            searchValue,
            setPage: (newPage) => dispatch(setPage(newPage)),
            setRowsPerPage: (newRowsPerPage) =>
              dispatch(setRowsPerPage(newRowsPerPage)),
            setIsOpenAddDialog: (value) => dispatch(setIsOpenAddDialog(value)),
            setSearchValue: (newValue) => dispatch(setSearchValue(newValue)),
          }}
        />
      </div>
      {isOpenAddDialog ? (
        <AddFileManagerWrapper onClose={() => dispatch(setIsOpenAddDialog(false))} />
      ) : null}
    </>
  );
};

export default FileManagerListingWrapper;
